module.exports = __webpack_public_path__ + "assets/images/pages/kfc/kfc-3.webp?59ceded1";